import React, { Fragment, useContext, useState } from 'react';
import Notify from '../../notification/Notify';
import Axios from 'axios';
import DeleteIcon from '@material-ui/icons/Delete';
import { Box, Typography, Table, TableContainer, TableBody, TableCell, TableRow, TableHead, TablePagination, Button, Zoom, Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import ReceiptIcon from '@material-ui/icons/Receipt';
import PaymentForm from './PaymentForm';
import { CancelOutlined } from '@material-ui/icons';
import { UsersData } from '../../ContextAPI';

function PurchaseList({ purchaseData, fetchPuchaseList }) {
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(0);
    const [paymentModal, setPaymentModal] = useState(false);
    const userData = useContext(UsersData);

    const handleDeltePurchase = (id, prod_id, batch, expiry) => {
        var params = { user_id: userData.users.user_id, management_id: userData.users.management_id, id: id, prod_id: prod_id, batch: batch, expiry: expiry }
        Axios.post('pharmacy/delete-purchase-id', params)
            .then(() => {
                Notify.successRequest('delete purchase');
                fetchPuchaseList();
            }).catch(error => {
                Notify.requestError(error);
            });
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    return (
        <Fragment>
            <Box display="flex" p={1}>
                <Box flexGrow={1} />
                <Box hidden={parseFloat(purchaseData.data.length) === 0}>
                    <Button variant="contained" color="primary" onClick={() => setPaymentModal(true)} startIcon={<ReceiptIcon />}>
                        Payment
                    </Button>
                </Box>
            </Box>
            <Box p={1}>
                <TableContainer component={Box}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center"> PRODUCT </TableCell>
                                <TableCell align="center"> QTY </TableCell>
                                <TableCell align="center"> PRICE </TableCell>
                                <TableCell align="center"> AMOUNT </TableCell>
                                <TableCell align="center"> ACTION </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                purchaseData.ready ?
                                    purchaseData.data.length > 0 ?
                                        purchaseData.data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((data, index) => (
                                                <TableRow key={index}>
                                                    <TableCell > {data.product} </TableCell>
                                                    <TableCell align="right">{data.purchase_quantity}</TableCell>
                                                    <TableCell align="right">{data.price}</TableCell>
                                                    <TableCell align="right">{data.total}</TableCell>
                                                    <TableCell align="center">
                                                        <DeleteIcon
                                                            color="secondary"
                                                            onClick={() => handleDeltePurchase(data.id, data.product_id, data.batch_no, data.expiry_date)}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        : <TableRow>
                                            <TableCell colSpan={5} align="center">
                                                <Typography variant="subtitle2" color="secondary"> No purchase added </Typography>
                                            </TableCell>
                                        </TableRow>
                                    : <TableRow>
                                        <TableCell colSpan={5} align="center">
                                            <Typography variant="subtitle2" color="primary"> Loading... </Typography>
                                        </TableCell>
                                    </TableRow>
                            }
                        </TableBody>
                    </Table>
                    <TablePagination
                        component={"div"}
                        rowsPerPageOptions={[5, 10, 25]}
                        colSpan={3}
                        count={purchaseData.data.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                </TableContainer>
            </Box>

            <Dialog
                open={paymentModal}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                TransitionComponent={Zoom}
                transitionDuration={1000}
                disableBackdropClick={true}
                maxWidth="md"
                fullWidth
            >
                <Box display="flex">
                    <Box flexGrow={1}>
                        <DialogTitle id="alert-dialog-title">{"Payment Form"}</DialogTitle>
                    </Box>
                    <Button onClick={() => setPaymentModal(false)}>
                        <CancelOutlined fontSize="large" color="secondary" />
                    </Button>
                </Box>
                <DialogContent dividers>
                    <PaymentForm purchaseData={purchaseData} fetchPuchaseList={() => fetchPuchaseList()} closeModal={() => setPaymentModal(false)} />
                </DialogContent>
            </Dialog>
        </Fragment>
    )

}

export default PurchaseList;